import React, { useEffect } from 'react';
import { toast } from 'react-toastify';

import { isArray } from 'lodash';
//import moment from 'moment';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Checkbox, Input } from '~/components/Form';

import { t } from '~/helpers';
import api from '~/services/api';

import { ContainerForm } from './styles';

export default function MyForm({ data, reference, close }) {

  const [modoAnteriorStr, setModoAnteriorStr] = React.useState('');
  const [labelModoTerminal, setLabelModoTerminal] = React.useState('');
  const [modoSiteComAbastecimento, setModoSiteComAbastecimento] = React.useState('0');


  async function handleSubmit(param) {
    try {

      const schema = Yup.object().shape({
        chkModoTerminal: Yup.number()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .transform((value) => (isNaN(value) ? undefined : value))
          .integer(t('s.geral.validacao.campoobrigatorio'))
          .min(1, t('s.geral.validacao.campoobrigatorio').replace('%s', 0)),
      });

      await schema.validate(param, {
        abortEarly: false,
      });

      const novochkModoTerminal = param.chkModoTerminal;

      let modoAbastecimento = '';


      if (modoSiteComAbastecimento) {

        if (param.chkModoSiteComAbastecimento) {
          modoAbastecimento = 'S';
        } else {
          modoAbastecimento = 'N';
        }
      } else {
        modoAbastecimento = 'S';
      }

      const codPosto = data.poco_codigo;
      const descricaoPosto = data.poco_descricao;
      const modoAnteriorTurnoTerminal = data.poco_turno_terminal;

      let modoNovo = '';


      if (String(modoAnteriorTurnoTerminal) === 'S') {
        modoNovo = 'N';
      } else {
        if (novochkModoTerminal === 1) {
          modoNovo = 'S';
        } else {
          modoNovo = 'N';
        }
      }


      const objSend = {
        codPosto,
        descricaoPosto,
        modoAnteriorTurnoTerminal,
        modoNovo,
        modoAbastecimento,
        idlogin: '',
      };

      await api.put('alterarmodooperacaoposto', objSend);
      toast.success(t('s.geral.sucessoalteracao'));

      await close();
    } catch (err) {
      if (isArray(err)) {
        err.map((e) => toast.error(e));
      }

      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    }
  }

  useEffect(() => {
    reference.current.setData(data);

    setModoAnteriorStr(`${data.posto_modo_operacao} ${data.poco_abastec_modo_site_str}`);

    if (String(data.poco_turno_terminal) === 'S') {
      setLabelModoTerminal('Alterar para modo site');
      setModoSiteComAbastecimento(true);
    } else {
      setLabelModoTerminal('Alterar para modo terminal')
      setModoSiteComAbastecimento(false);
    }

  }, []);

  return (
    <>
      <ContainerForm ref={reference} initialData={data} onSubmit={handleSubmit}>


        <Input
          name="poco_descricao"
          label='Posto'
          value={data.poco_descricao}
          disabled
        />

        <Input
          name="modoanterior"
          label='Modo Atual:'
          value={modoAnteriorStr}
          disabled
        />

        <Checkbox
          name="chkModoTerminal"
          label={labelModoTerminal}
          //disabled={typeUser === 'U'}
          //style={{ marginBottom: '3rem' }}
          serialize={(value) => Number(value)}
        />

        <Checkbox
          name="chkModoSiteComAbastecimento"
          label="Selecione para modo Site com Abastecimento"
          disabled={!modoSiteComAbastecimento}
          //style={{ marginBottom: '3rem' }}
          serialize={(value) => Number(value)}
        />

      </ContainerForm>
    </>
  );
}

MyForm.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  close: PropTypes.func.isRequired,
};
